import Effects from 'Effects';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

class GainEffect extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Gain', () => new Tone.Gain(1), sequencerEngine); 
        this.effectNode.gain.value = 1;

        this.gainParameter = new AudioParamValueParameter(
            'Gain', this.effectNode.gain, {
                documentation: "Controls the gain (or loudness) of the signal before it hits the compressor",
                min: 0,
                max: 6,
                unit: 'db',
                defaultValue: 1
            });
        this.registerParameter(this.gainParameter);
        this.updateInitialValues();
    }

    get documented() {
        return "Reduces the volume of loud sounds or amplifies quiet sounds.";
    }

    getJson(isPreset) {
        let json = super.getJson();
        json.gain = this.gainParameter.get();
        json = this.saveParameterToJson(json, 'gainParameter', this.gainParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        if ('gain' in json) {
            bulkUpdate(this.gainParameter, json.gain, bulk);
        }
        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'gainParameter', this.gainParameter, isCopy),
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new GainEffect(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default GainEffect;
